module.exports = {

    props: {
        data: {
            required: true,
        },
    },

    data(){
        return {
            isSubmitted: false,
            form: new Form({
                comments: this.data ? this.data.comments : '',
                testResult: this.data ? this.data.testResult : false
            }, false)
        }
    },

    mounted () {
        this.resolveTest();
    },

    methods:{

        resolveTest () {
            setInterval(() => {
                this.constructionInspection();
                this.evaluateTest();
            }, 250)
        },

        save(event) {
            this.isSubmitted = true;
            $('#test-form').submit();
        },

        isBlank(value) {
            return $.trim(value) == '';
        },

        asNumber(val) {
            return (isNaN(val) || val == "") ? '' : eval(val)
        },

        formatResult(result) {
            return (!isNaN(result) && result != 'Infinity' && result != '-Infinity') ? result : '';
        }
    },

    computed: {
        testIsReady() {
            return true;
        }
    }

}
